import { createRoot } from "react-dom/client";
import "@fontsource-variable/inter";
import App from "./App.tsx";
import "./index.css";

const root = document.getElementById("root")!;

createRoot(root).render(<App />);

/**
 * Signal für den Prerenderer (siehe vite.config.ts).
 *
 * Beim Build rendert Puppeteer jede Route und wartet auf dieses Attribut,
 * bevor es das HTML abgreift. Zwei verschachtelte rAF stellen sicher, dass
 * React mindestens einmal gemalt hat — sonst landet womöglich ein leerer
 * oder halbfertiger Baum im statischen HTML.
 *
 * Im Browser ist das Attribut folgenlos.
 */
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    root.setAttribute("data-prerender-ready", "");
  });
});
